<template>
    <v-container class="pa-5" fluid>
        <PriceListDialog
            :is-open="priceListDialog"
            :price-list-name="priceListName"
            @on-save="getPapers()"
            @on-close="closePriceListDialog"
        />
        <SavePaperDialog
            :paper="paper"
            :paper-groups="paperGroups"
            :coating-types="coatingTypes"
            :prinergy-paper-types="prinergyPaperTypes"
            :is-open="savePaperDialog"
            @on-save="getPapers"
            @on-close="closeSavePaperDialog"
        />

        <v-row align="center" dense>
            <v-col cols="auto">
                <page-title>Papiery</page-title>
            </v-col>
            <v-col cols="auto">
                <SelectMenu />
            </v-col>
        </v-row>

        <v-row align="center">
            <v-col cols="12" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Dodaj papier"
                    @click="showCreatePaperDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj papier
                </v-btn>
            </v-col>
            <v-col cols="12" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="filters.isVisible"
                                label="Ukryj nieaktywne"
                                hide-details
                                class="mt-2"
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-select
                                v-model="filters.group_id"
                                :items="paperGroups"
                                item-value="id"
                                placeholder="Grupa papierów..."
                                no-data-text="Brak danych..."
                                hide-details
                                solo
                                clearable
                                @change="changeFilter"
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.name }}
                                </template>

                                <template slot="item" slot-scope="data">
                                    {{ data.item.name }}
                                    <v-chip
                                        v-if="!data.item.isVisible"
                                        color="red"
                                        text-color="red"
                                        small
                                        outlined
                                    >
                                        nieaktywna
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                                v-model="filters.name"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('name')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row v-if="canImportExportFile" justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj cennik"
                    :disabled="generatePapersPriceListLoading"
                    @click="generatePapersPriceList"
                >
                    <v-icon
                        v-if="!generatePapersPriceListLoading"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj cennik
                </v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Importuj cennik"
                    @click="showPriceListDialog"
                >
                    <v-icon
                        small
                        color="primary"
                    >
                        mdi-file-excel
                    </v-icon>
                    Importuj cennik
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="papers"
                        :loading="papersLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="papersData"
                        @pagination="updatePagination"
                    >
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.groupName="{item}">
                            {{ item.group.name }}
                            <v-chip
                                v-if="!item.group.isVisible"
                                color="red"
                                text-color="red"
                                small
                                outlined
                                disabled
                            >
                                nieaktywna
                            </v-chip>
                        </template>
                        <template #item.coatingType="{item}">
                            {{ item.coatingType.name }}
                        </template>
                        <template #item.isVisible="{item}">
                            <v-icon
                                v-if="item.isVisible"
                                small
                                color="success"
                            >
                                mdi-check
                            </v-icon>
                            <v-icon v-else small color="error">
                                mdi-close
                            </v-icon>
                        </template>
                        <template #item.piecePrice="{item}">
                            {{ formatPrice(item.piecePrice) }}
                        </template>
                        <template #item.prinergyPaperTypeName="{item}">
                            {{ item.prinergyPaperType ? item.prinergyPaperType.name : '-' }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showEditPaperDialog(item.id)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edytuj</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Ukryj"
                                            v-on="on"
                                            @click="hidePaper(item.id)"
                                        >
                                            <v-icon color="pink">
                                                mdi-eye-off
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ukryj</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/store'
import PageTitle from '@/components/common/PageTitle'
import SavePaperDialog from './SavePaperDialog'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import priceFormatter from '@/mixins/priceFormatter'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import { hasUserPermission } from '@/utils/permissionsHandler'
import SelectMenu from '@/views/Configurations/Materials/Common/SelectMenu'
import PriceListDialog from '@/views/Configurations/Materials/Common/PriceListDialog'

export default {
    name: 'Papers',
    components: {
        PageTitle,
        SavePaperDialog,
        SelectMenu,
        PriceListDialog
    },
    mixins: [
        filters,
        pagination,
        tooltipDelay,
        priceFormatter
    ],
    beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch('configurations/getPaperGroups'),
            store.dispatch('configurations/getCoatingTypes'),
            store.dispatch('configurations/getPrinergyPaperTypes')
        ])
            .then(() => {
                next()
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('configurations/clearPapersFilters')
        next()
    },
    data() {
        return {
            paper: {},
            savePaperDialog: false,
            generatePapersPriceListLoading: false,
            user: null,
            priceListDialog: false,
            importPapersPriceListLoading: false,
            priceListName: null,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Grupa',
                    value: 'groupName',
                    sortable: false,
                },
                {
                    text: 'Rodzaj powleczenia',
                    value: 'coatingType',
                    sortable: false,
                },
                {
                    text: 'Cena za sztukę (zł)',
                    value: 'piecePrice',
                    sortable: false,
                    align: 'center',
                    width: 140
                },
                {
                    text: 'Gramatura (g)',
                    value: 'weight',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Typ prinergy',
                    value: 'prinergyPaperTypeName',
                    sortable: false,
                    align: 'center',
                    width: 100
                },
                {
                    text: 'Czy aktywny?',
                    value: 'isVisible',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        papers() {
            return this.$store.getters['configurations/getPapers']
        },
        paperGroups() {
            return this.$store.state.configurations.paperGroups.paperGroups
        },
        coatingTypes() {
            return this.$store.state.configurations.papers.coatingTypes
        },
        prinergyPaperTypes() {
            return this.$store.state.configurations.papers.prinergyPaperTypes
        },
        papersLoading() {
            return this.$store.state.configurations.papers.papersLoading
        },
        canImportExportFile() {
            return hasUserPermission('papers_price_update')
        },
        savedFilters() {
            return this.$store.state.configurations.papers.filters
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    if (!(item === 'isVisible' && filters[item] === false)) {
                        query = query.concat('&', `${item}=${filters[item]}`)
                    }
                }
            }

            return query
        }
    },
    mounted() {
        this.$store.dispatch('administration/getUser', this.userId )
            .then(response => {
                this.user = response.data
                this.getPapers()
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        getPapers() {
            this.$store.dispatch('configurations/getPapers', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getPaper(paperId) {
            return this.$store.getters['configurations/getPaperById'](paperId)
        },
        showCreatePaperDialog() {
            this.$store.dispatch('configurations/getPaperGroups')
                .then(() => {
                    this.savePaperDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showEditPaperDialog(paperId) {
            this.$store.dispatch('configurations/getPaperGroups')
                .then(() => {
                    this.paper = this.getPaper(paperId)
                    this.savePaperDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeSavePaperDialog() {
            this.savePaperDialog = false

            setTimeout(() => {
                this.paper = {}
            }, 500)
        },
        hidePaper(paperId) {
            this.$store.dispatch('configurations/updatePaper', {
                id: paperId,
                isVisible: false
            })
                .then(() => {
                    this.getPapers()
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        generatePapersPriceList() {
            this.generatePapersPriceListLoading = true
            this.$store.dispatch('configurations/generatePapersPriceList', {
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.generatePapersPriceListLoading = false
                })
        },
        showPriceListDialog() {
            this.priceListDialog = true
            this.priceListName = 'papers'
        },
        closePriceListDialog() {
            this.priceListDialog = false
        },
        changeFilter() {
            this.$store.dispatch('configurations/setPapersFilters', this.filters)
            this.resetPagination()
            this.getPapers()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getPapers()
            }
            this.clearPaginationPending()
        },
    }
}
</script>
